import PropTypes from 'prop-types';

import checkedImg from '../../assets/svg/checkbox-checked.svg';
import uncheckedImg from '../../assets/svg/checkbox-unchecked.svg';

const Checkbox = ({
  checked, onChange = undefined, id, label = '',
}) => (
  <label className="flex gap-2" aria-checked={checked} htmlFor={id}>
    <input
      className="hidden"
      type="checkbox"
      id={id}
      checked={checked}
      onChange={(e) => {
        e.preventDefault();
        if (onChange) {
          onChange(!checked);
        }
      }}
      aria-hidden="true"
      tabIndex={-1}
    />
    <span className="w-8">
      {checked ? (
        <img src={checkedImg} alt={`Checked checkbox for ${id}`} />
      ) : (
        <img src={uncheckedImg} alt={`Unchecked checkbox for ${id}`} />
      )}
    </span>
    <span>{label}</span>
  </label>

);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default Checkbox;
